import {RouteInfo} from "../../route/RouteHelper";

export const SidebarItemsType = {
    COLLAPSE: "COLLAPSE",
    SIMPLE_ITEM: "SIMPLE_ITEM",
    HEADER_ITEM: "HEADER_ITEM",
}

export const sideBarListItemsClerk = [
    {
        info: "خانه",
        type: SidebarItemsType.HEADER_ITEM
    }, {
        info: RouteInfo.Dashboard,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: "مقالات",
        type: SidebarItemsType.HEADER_ITEM,
        accessRole: [...RouteInfo.NewsList.accessRole, ...RouteInfo.SpecialNewsList.accessRole]
    }, {
        info: RouteInfo.NewsList,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.SpecialNewsList,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: "اسلایدر",
        type: SidebarItemsType.HEADER_ITEM,
        accessRole: [...RouteInfo.SliderList.accessRole]
    }, {
        info: RouteInfo.SliderList,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: "چندرسانه ای",
        type: SidebarItemsType.HEADER_ITEM,
        accessRole: [...RouteInfo.MultiMediaList.accessRole]
    }, {
        info: RouteInfo.MultiMediaList,
        type: SidebarItemsType.SIMPLE_ITEM
    },
    /*{
        info: RouteInfo.GalleryList,
        type: SidebarItemsType.SIMPLE_ITEM
    }, */
    {
        info: "مدیریت",
        type: SidebarItemsType.HEADER_ITEM,
        accessRole: [...RouteInfo.ManagersAccess.accessRole, ...RouteInfo.ManagersList.accessRole,]
    }, {
        info: RouteInfo.ManagersAccess,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.ManagersList,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: "روابط عمومی",
        type: SidebarItemsType.HEADER_ITEM,
        accessRole: [...RouteInfo.ContactUsList.accessRole]
    }, {
        info: RouteInfo.ContactUsList,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: "فایل ها",
        type: SidebarItemsType.HEADER_ITEM,
        accessRole: [...RouteInfo.Files.accessRole]
    }, {
        info: RouteInfo.Files,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: "اسناد",
        type: SidebarItemsType.HEADER_ITEM,
        accessRole: [...RouteInfo.ReleaseDocuments.accessRole]
    }, {
        info: RouteInfo.ReleaseDocuments,
        type: SidebarItemsType.SIMPLE_ITEM
    },
    /*{
        info: "کامپوننت های آماده",
        type: SidebarItemsType.HEADER_ITEM
    }, {
        info: RouteInfo.DefaultListPage,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.DefaultInputsPage,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.Category,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.Exam,
        type: SidebarItemsType.SIMPLE_ITEM
    },*/
    /*{
        info: RouteInfo.AppVersionList,
        type: SidebarItemsType.SIMPLE_ITEM
    },*/


]


